/* @flow */

import * as React from 'react';

import useNotificationPortal from './hook/useNotificationPortal';
import useMounted from 'src/shared/app/base/hook/useMounted';
import NotificationContainerDumb from 'src/shared/app/notification/component/NotificationContainerDumb';
import useReduxState from 'src/shared/app/base/hook/useReduxState';
import useFeatureDecisions from 'src/shared/app/feature/hook/useFeatureDecisions';
import {
  isOnboardingScreenShown,
  isPermissionScreenShown,
} from 'src/shared/app/base/route/util/routeUtilsSelectors';
const NotificationPortal = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const isMounted = useMounted();
  const { queue } = useNotificationPortal();
  const state = useReduxState();
  const { areEmailNotificationsEnabled } = useFeatureDecisions();
  const hideNotifs =
    isOnboardingScreenShown(state) ||
    isPermissionScreenShown(state, areEmailNotificationsEnabled);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  if (isMounted && !hideNotifs) {
    return (
      <NotificationContainerDumb queue={queue}></NotificationContainerDumb>
    );
  }

  return null;
};

export default React.memo<{}>(NotificationPortal);
